import { render, staticRenderFns } from "./ModalAnnouncementConfirmDelete.vue?vue&type=template&id=0e71f76e&"
import script from "./ModalAnnouncementConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ModalAnnouncementConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
